<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AJqjIY/tc-custom/9780253061973.jpg?1724781543354" alt="This image is the cover for the book Fat Boy and the Champagne Salesman"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fat Boy and the Champagne Salesman
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Fat Boy and the Champagne Salesman </i>offers a compelling behind-the-scenes exploration of the road to World War II and the invasion of Poland by the Hitler's Third Reich. Focusing on the personal power plays within Hitler's inner circle, author Rush Loving details the struggle for Hitler's approval, long before the battle for Poland had begun.<br/> <br/>The rivalry was between "Fat Boy," the moniker given to Hermann Göring by his fellow Nazi generals, and "the Champagne Salesman," Joachim von Ribbentrop, nicknamed for his previous career, and it was at the heart of Germany's plans for the expansion of the Reich into Poland. Göring, founder of the Lüftwaffe and the man who oversaw the armaments industry, was convinced that any invasion of Poland would lead to war with England and France, who were committed to its defense. Von Ribbentrop, Hitler's foreign minister, argued that the Allies would stand down and continue their policy of appeasement. Only one would be proved correct. <br/> <br/>An engrossing and dramatic tale, <i>Fat Boy and the Champagne Salesman</i> shows Göring and Ribbentrop playing a tug-of-war with Hitler's will. Loving's vivid narrative of the struggle between the two advisers lends a new understanding of the events leading to the opening days of World War II.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rush Loving
      </h2>
      
      <p class="authorDescription body article"><P>Rush Loving Jr. is former associate editor of Fortune and former business editor of the Richmond Times-Dispatch. He is author of <I>The Men Who Loved Trains</I> and <I>The Well-Dressed Hobo</I>. Loving also served as assistant director of the Office of Management and Budget under President Jimmy Carter and worked as a consultant specializing in transportation economics, issues before Congress, and corporate communication problems.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?122ab85c